import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {Sync} from '@client/sync'
import {IconButton} from '@components/common/base/buttons'
import {Icon} from '@components/common/base/icon'
import {
  showDeleteConfirm
} from '@components/common/base/notifications'
import {WaitingSwitcher} from '@components/common/base/switcher/switcher'
import {useTaskTemplatesStore} from './task-templates-store'

const TwContainer = tw.div`
  group
  flex
  items-center
  gap-8
  cursor-pointer
  p-8
  rounded-8
  hover:bg-background-hover
`

const TwText = tw.div`
  plain-text-regular
  text-primary
  truncate
`

const TwLeftPanel = tw.div`
  flex
  items-center
  gap-16
  ml-auto
  h-24
`

const TwActions = tw.div`
  hidden
  items-center
  gap-16
  group-hover:flex
`

export interface Props {
  id: DataObjectId
  enabled: boolean
  text: string
}

export const TaskTemplateRow = (props: Props) => {
  const [, store] = useTaskTemplatesStore()
  const {id, enabled, text} = props

  const onToggle = (e: React.MouseEvent) => {
    e.stopPropagation()

    const box = Sync.getCurrentSandbox()
    const template = box.getHub(id)
    if (!template) {
      logger.warn('Cannot find movement template', id)
      return
    }

    const curr = template.data.taskTemplate.enabled
    template.data.taskTemplate.enabled = !curr
    template.commit()
  }

  const onDelete = async (e: React.MouseEvent) => {
    e.stopPropagation()

    if (await showDeleteConfirm(Lang.msg.taskTemplates.messageDeleteConfirm)) {
      const box = Sync.getCurrentSandbox()
      const template = box.getHub(id)
      if (!template) {
        logger.warn('Cannot find task template', id)
        return
      }

      template.deleted = true
      template.commit()
    }
  }

  const onEdit = () => {
    store.goToEdit(id)
  }

  return (
    <TwContainer onClick={onEdit}>
      <Icon icon="IconCustomTemplate" />
      <TwText>{text}</TwText>

      <TwLeftPanel>
        <TwActions>
          <IconButton
            onClick={onDelete}
            size="small"
            icon="IconTrash"
            color="error"
          />
        </TwActions>

        <WaitingSwitcher active={enabled} onClick={onToggle} />
      </TwLeftPanel>
    </TwContainer>
  )
}
